import urlConstants from '~/lib/constants/url.constants';
import api from './api';
import { CacheTag } from './CacheTag';

const { getPatientChartUrl, getLabNetwork } = urlConstants.labs;

export const labsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getLabNetworkUrl: build.query<{ url: string }, string>({
      query: (patientExternalId) => getLabNetwork(patientExternalId),
    }),
    getPatientChartUrl: build.query<
      { url: string },
      {
        patientExternalId: string;
        diagnosticReportId?: string;
        showOrders?: boolean;
      }
    >({
      providesTags: [CacheTag.LabPatientChart],
      keepUnusedDataFor: 45 * 60,
      query: ({ patientExternalId, diagnosticReportId, showOrders }) => ({
        url: getPatientChartUrl(patientExternalId),
        params: {
          'diagnostic-report-id': diagnosticReportId,
          'show-orders': showOrders,
        },
      }),
    }),
  }),
});

export const { useGetPatientChartUrlQuery, useGetLabNetworkUrlQuery } = labsApi;
